import ClockIcon from "../../../icons/subscription-status/clock.icon";
import User2Icon from "../../../icons/subscription-status/user-2.icon";
import QuestionPageIcon from "../../../icons/question-page.icon";
import cn from "../../../../Utils/class-names.utils";
import styles from "./sections.module.scss";

interface DateSectionProps {
  days?: string;
  expiringDate?: string;
  byUser?: string;
  reason?: string;
  showButton?: boolean;
  onViewDetails?: () => void;
}

const DateSection = ({ days, expiringDate, byUser, reason, showButton, onViewDetails }: DateSectionProps) => {
  return (
    <div className="d-flex gap-8 flex-1">
      <div style={{ marginTop: '-1px' }}>
        <ClockIcon />
      </div>
      <div className="d-flex flex-column gap-4">
        <span className="f-12 line-height-18 f-400 f-grey">
          {`${days}${expiringDate ? `. Expiring ${expiringDate}` : ''}`}
        </span>
        {(byUser || reason) && (
          <div className="d-flex flex-column gap-8">
            {byUser && (
              <div className="d-flex align-items-center gap-8">
                <span className="f-12 line-height-18 f-400 f-grey">by</span>
                <User2Icon />
                <span className="f-12 line-height-18 f-400 f-grey">{byUser}</span>
              </div>
            )}
            {reason && (
              <span className="f-12 line-height-18 f-400 f-darkgrey">"{reason}"</span>
            )}
          </div>
        )}
        {showButton && (
          <button
            type="button"
            className={cn(
              styles.primaryButton,
              "my-button styled",
              "d-flex align-items-center gap-2"
            )}
            aria-label="View Details"
            onClick={onViewDetails}
          >
            <div className={styles.primaryButtonInner}>
              <QuestionPageIcon width={15} height={17} />
            </div>

            <div className={cn(styles.footerButtonText, "text")}>
              <span className={styles.primaryText}>View Details</span>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default DateSection;
